import React from 'react';
import { TAB_CONFIGS } from '../misc/tabConfigs';

import '../styles/TabSelector.css';

export default function TabSelector({ activeTab, onTabChange }) {
  return (
    <div className="tabs">
      {TAB_CONFIGS.map(tab => (
        <button
          key={tab.id}
          className={`tab-button ${activeTab === tab.id ? 'selected' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <img src={tab.iconActive} alt={tab.alt} />
          <span className="tooltip">{tab.alt}</span>
        </button>
      ))}
    </div>
  );
}